import { useState } from 'react'
import { Cable } from '@digital-twins/design-system/icons'
import { cn } from '@/lib/utils'
import type { LibrarySourceMarkProps } from '@/types/components/connectors/marketplace'

/** Brand assets come from the integration catalogue, rather than hand-drawn marks. */
export function LibrarySourceMark({ slug, logoUrl, className }: LibrarySourceMarkProps) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null)
  const showLogo = Boolean(logoUrl && logoUrl !== failedUrl)
  return (
    <span
      className={cn('flex size-12 shrink-0 items-center justify-center overflow-hidden rounded-xl border border-border/70 bg-card p-2.5', className)}
      aria-hidden="true"
    >
      {showLogo ? (
        <img src={logoUrl!} alt="" className="size-full object-contain" loading="lazy" decoding="async"
          referrerPolicy="no-referrer" onError={() => setFailedUrl(logoUrl!)} data-testid={`integration-logo-${slug}`} />
      ) : <Cable className="size-6 text-muted-foreground" />}
    </span>
  )
}
